const Url = (endpoint) => {
    const domain =
        import.meta.env.VITE_API_URL ??
        "http://localhost:3023";
    return domain + "/" + endpoint;
};

export default Url;
export const urlDashboard =
    import.meta.env.VITE_DASHBOARD ??
    "https://dashboard-api2.abc-elearning.org/";
// "http://localhost:8000/";
